"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyFlpPickList = exports.filterHiddenFlp = exports.buildHiddenFlpSet = exports.sortFlpByPickList = exports.compareFlpBySlug = exports.buildFlpRankMap = exports.FLP_ORDER_AND_VISIBILITY_PICK_LIST_ID = void 0;
exports.FLP_ORDER_AND_VISIBILITY_PICK_LIST_ID = 'flpSubscriptionTypeOrderAndVisibility';
const UNRANKED = Number.MAX_SAFE_INTEGER;
const buildFlpRankMap = (pickList) => {
    var _a;
    return new Map(((_a = pickList === null || pickList === void 0 ? void 0 : pickList.values) !== null && _a !== void 0 ? _a : [])
        .filter(item => Boolean(item === null || item === void 0 ? void 0 : item.key) && (item === null || item === void 0 ? void 0 : item.value) !== '' && !Number.isNaN(Number(item === null || item === void 0 ? void 0 : item.value)))
        .map(item => [item.key, Number(item.value)]));
};
exports.buildFlpRankMap = buildFlpRankMap;
const compareFlpBySlug = (rank) => (a, b) => {
    var _a, _b, _c, _d, _e, _f;
    const rankA = (_b = rank.get((_a = a === null || a === void 0 ? void 0 : a.slug) !== null && _a !== void 0 ? _a : '')) !== null && _b !== void 0 ? _b : UNRANKED;
    const rankB = (_d = rank.get((_c = b === null || b === void 0 ? void 0 : b.slug) !== null && _c !== void 0 ? _c : '')) !== null && _d !== void 0 ? _d : UNRANKED;
    if (rankA !== rankB)
        return rankA - rankB;
    return ((_e = a === null || a === void 0 ? void 0 : a.name) !== null && _e !== void 0 ? _e : '').localeCompare((_f = b === null || b === void 0 ? void 0 : b.name) !== null && _f !== void 0 ? _f : '');
};
exports.compareFlpBySlug = compareFlpBySlug;
const sortFlpByPickList = (items, pickList) => {
    const rank = (0, exports.buildFlpRankMap)(pickList);
    if (!rank.size)
        return items;
    return [...items].sort((0, exports.compareFlpBySlug)(rank));
};
exports.sortFlpByPickList = sortFlpByPickList;
const buildHiddenFlpSet = (pickList) => {
    var _a;
    return new Set(((_a = pickList === null || pickList === void 0 ? void 0 : pickList.values) !== null && _a !== void 0 ? _a : [])
        .filter(item => Boolean(item === null || item === void 0 ? void 0 : item.key) && typeof (item === null || item === void 0 ? void 0 : item.hidden) === 'boolean' && item.hidden)
        .map(item => item.key));
};
exports.buildHiddenFlpSet = buildHiddenFlpSet;
const filterHiddenFlp = (items, pickList) => {
    const hidden = (0, exports.buildHiddenFlpSet)(pickList);
    if (!hidden.size)
        return items;
    return items.filter(item => { var _a; return !hidden.has((_a = item === null || item === void 0 ? void 0 : item.slug) !== null && _a !== void 0 ? _a : ''); });
};
exports.filterHiddenFlp = filterHiddenFlp;
const applyFlpPickList = (items, pickList) => (0, exports.sortFlpByPickList)((0, exports.filterHiddenFlp)(items, pickList), pickList);
exports.applyFlpPickList = applyFlpPickList;
//# sourceMappingURL=flpOrderAndVisibility.js.map